export function formatAED(n) {
  const num = Number(n || 0);
  return `AED ${num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatMoney(n, ccy = "AED") {
  const num = Number(n || 0);
  return `${ccy || "AED"} ${num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatNumber(n) {
  const num = Number(n || 0);
  return num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatDate(d) {
  if (!d) return "—";
  try {
    const date = typeof d === "string" ? new Date(d) : d;
    return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return String(d);
  }
}

export function formatDateTime(d) {
  if (!d) return "—";
  try {
    const date = new Date(d);
    return date.toLocaleString("en-GB", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return String(d);
  }
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

const _ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
  "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const _TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
const _SCALES = [["", 1], ["Thousand", 1e3], ["Million", 1e6], ["Billion", 1e9]];

function _threeToWords(n) {
  let out = "";
  if (n >= 100) {
    out += _ONES[Math.floor(n / 100)] + " Hundred";
    n %= 100;
    if (n) out += " ";
  }
  if (n >= 20) {
    out += _TENS[Math.floor(n / 10)];
    if (n % 10) out += " " + _ONES[n % 10];
  } else if (n > 0) {
    out += _ONES[n];
  }
  return out;
}

export function numberToWords(num) {
  num = Math.floor(Math.abs(Number(num || 0)));
  if (num === 0) return "Zero";
  const parts = [];
  for (let i = _SCALES.length - 1; i >= 0; i--) {
    const [name, value] = _SCALES[i];
    const chunk = Math.floor(num / value);
    if (chunk > 0) {
      parts.push(_threeToWords(chunk) + (name ? " " + name : ""));
      num %= value;
    }
  }
  return parts.join(" ").trim();
}

const _CCY_NAME = {
  AED: ["Dirhams", "Fils"], USD: ["Dollars", "Cents"], EUR: ["Euros", "Cents"],
  GBP: ["Pounds", "Pence"], SAR: ["Riyals", "Halalas"], INR: ["Rupees", "Paise"],
};

export function amountToWords(amount, ccy = "AED") {
  const [maj, min] = _CCY_NAME[ccy] || [ccy || "AED", "Fils"];
  const n = Number(amount || 0);
  const whole = Math.floor(n);
  const minor = Math.round((n - whole) * 100);
  let s = `${numberToWords(whole)} ${maj}`;
  if (minor > 0) s += ` and ${numberToWords(minor)} ${min}`;
  return s + " Only";
}
